module.exports = __webpack_public_path__ + "static/media/2030085000.9c400849.jpg";